import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

export default function summaryCell(cellData) {
    var tokenKey = 'accessToken';
    var token = sessionStorage.getItem(tokenKey);
    var login = JSON.parse(atob(token.split(".")[1])).ManagerLogin;
    var checkAdmin = login !== "" && login !== undefined && login !== null && login === "admin";

    if (cellData.column.dataField == 'name') {
        if (cellData.data.itemType == 'item') {
            var cellDataValue = cellData.value.toString();
            if (cellDataValue.includes('ПИФ') && checkAdmin) {
                return (
                    <div className={cellData.data.itemType}>
                        <Link to={{
                        pathname: '/fundposition',
                        state: {
                            objectId: cellData.data.binPortfolioId,
                            type: "portfolio"
                        }
                        }}>
                        {cellData.value}
                        </Link>
                    </div>
                );
            }
            else if (cellDataValue.includes('ПИФ') && !checkAdmin)  {
                return (
                    <div className={cellData.data.itemType}>
                            {cellData.value}
                    </div>
                );
            }
            else
                return (
                <div className={cellData.data.itemType}><Link to={{
                    pathname: '/position',
                    state: {
                        objectId: cellData.data.binPortfolioId,
                        type: "portfolio"
                    }
                }}>{cellData.value}</Link></div>
            );
        } else {
            return (
                <div className={cellData.data.itemType}>{cellData.value}</div>
            );
        }
    }

    var cn = "value_" + cellData.data.itemType;

    if (cellData.column.dataField == 'rate' && cellData.data.itemType == "item") {
        return (
            <div className={cn}>{cellData.value.toLocaleString(
                'ru-RU',
                {
                    minimumFractionDigits: 2,
                    minimumFractionDigits: 2
                }
            )}</div>
        );
    }

    if (cellData.column.dataField == 'rateInCurrency') {
        return (
            <div className={cn}>{cellData.value.toLocaleString(
                'ru-RU',
                {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                }
            )}</div>
        );
    }

    if (cellData.column.dataField == 'percent') {
        if (cellData.value != null) {
            var val = (cellData.value * 100).toLocaleString('ru-RU', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
            });
            return (
                <div className={cn}>{val}%</div>
            );
        } else {
            return (
                <div></div>
                );
        }
    }
}


// WEBPACK FOOTER //
// ./App/containers/summary/summaryNameCell.jsx